import React, { useEffect, useState } from "react";
import { Transfer } from "antd";
import usePrivileges from "hooks/access-control/usePrivileges";

export default function AssignPrivilegesToRole({
  role,
  disabled,
  onPrivilegesChange,
  assignedPrivileges,
}) {
  const { privileges } = usePrivileges();
  const [data, setData] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]); // store assigned privileges
  const [originalAssignedIds, setOriginalAssignedIds] = useState([]); // to filter out already assigned ids

  // convert privileges to required format
  useEffect(() => {
    if (!privileges || privileges.length === 0) return;

    const formatted = privileges.map((p) => ({
      key: p.id.toString(),
      title: p.name,
      description: p.description || p.name,
    }));

    setData(formatted);
  }, [privileges]);

  // pre-select role privileges
  useEffect(() => {
    if (!assignedPrivileges) return;

    const selected = assignedPrivileges.map((p) => p.value.toString());
    setTargetKeys(selected);
    setOriginalAssignedIds(selected);
  }, [assignedPrivileges]);

  const filterOption = (inputValue, option) =>
    option.title.toLowerCase().includes(inputValue.toLowerCase()) ||
    option.description.toLowerCase().includes(inputValue.toLowerCase());

  const handleChange = (newTargetPrivs) => {
    if (disabled) return;
    setTargetKeys(newTargetPrivs);

    // identify only new privileges added by user
    const newPrivsOnly = newTargetPrivs.filter(
      (id) => !originalAssignedIds.includes(id)
    );

    // pass selected privileges to parent component
    onPrivilegesChange?.(newPrivsOnly);
  };

  return (
    <Transfer
      dataSource={data}
      showSearch
      filterOption={filterOption}
      targetKeys={targetKeys}
      onChange={handleChange}
      render={(item) => item.title}
      titles={["Available Privileges", "Assigned Privileges"]}
      disabled={disabled}
    />
  );
}
